import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../core/settings/settings.service';
import { AuthService } from '@app/core/services/auth.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    constructor(private settings: SettingsService, private router: Router, private authService: AuthService) { 

        // Check token data
        if (this.authService.getLoggedUserInfoFromLocalStorage()?.accessToken === null) {
            this.settings.sessionExpired();
            this.router.navigate(["/login"]);
        }

    }

    ngOnInit() {
    }

}
